import Typography from "../v2/typography";
import { ValidationMessageProps } from "./types";
import ValidationBox from "./validationBox";

/**
 * Component to show a validation message if the user's selections are not valid.
 * @param interface
 * @returns a box with text.
 */
export const ValidationMessage = ({ messages }: ValidationMessageProps) => (
  <ValidationBox>
    <div className="text-red">
      {messages.map(message => (
        <Typography key={message}>- {message}</Typography>
      ))}
    </div>
  </ValidationBox>
);
